@if (
    isMobile() 
    || alwaysShowInfoIcon
) {
    <label 
        class="for" 
        [style.font-size]="labelFontSize"
    >
        {{ labelText }}
        @if (
            tooltip 
            && labelText
        ) {
            <fa-icon 
                class="icon-tooltip" 
                [icon]="faIconName.faInfoCircle" 
                ngbTooltip="" 
                [ngbTooltip]="tooltip" 
                triggers="click" 
                container="body" 
                [placement]="tooltipPlacement || 'auto'"
            ></fa-icon>	
        }
    </label>
} @else {
    <label 
        class="for" 
        [style.font-size]="labelFontSize" 
        ngbTooltip="" 
        [ngbTooltip]="tooltip" 
        container="body"
    >{{ labelText }}</label>
}